/**
 * Erlang
 * ------
 * 
 * June 2026
 */

import { InputNumber } from "primereact/inputnumber";

/**
 * Distribution component for editing the parameters of an erlang distribution.
 * 
 * @param {Object} element          - Attributes for an element being edited.
 * @param {Object} attr             - Distribution parameters tied with element attribute.
 * @param {Function} distUpdater    - Sets which distribution is currently being used.
 */
function Erlang({ elementType, element, attr, distUpdater, warningUpdater, configWarnings }) {
    const erlangWarnings = {
        'shape': function(newShape) { return newShape < 1 ? `${attr} - shape must be positive.` : null},
        'scale': function(newScale) { return newScale < 1 ? `${attr} - scale must be positive.` : null}
    }

    /**
     * Updates the erlang distribution parameters for an attribute.
     * 
     * Example parameters:
     *  - shape
     *  - scale
     * 
     * @param {String} erlangParam  - Erlang parameter being updated.
     * @param {Number} newValue     - Updated value for the erlang parameter.
     */
    const handleErlang = (erlangParam, newValue) => {
        const newErlang = {...element[attr].attr, [erlangParam]: newValue};
        const newDist = {...element[attr], attr: newErlang};

        warningUpdater(element.gid, attr, erlangWarnings['shape'](newErlang.shape) || erlangWarnings['scale'](newErlang.scale))
        // console.log("New erlang distribution: ", newErlang);
        distUpdater(attr, newDist);
    }

    return (
        <div>
            <div style={{ marginBottom: '0.5rem' }}>
                <label style={{ marginRight: '0.5rem' }}>Shape:</label>
                <InputNumber value={element[attr].attr.shape} onValueChange={(event) => handleErlang('shape', event.target.value)} invalid={!!configWarnings[elementType]?.[element.gid]?.[attr]} inputStyle={{ width: '110px' }}/>
            </div>
            <div style={{ marginBottom: '0.5rem' }}>
                <label style={{ marginRight: '0.5rem' }}>Scale:</label>
                <InputNumber value={element[attr].attr.scale} onValueChange={(event) => handleErlang('scale', event.target.value)} invalid={!!configWarnings[elementType]?.[element.gid]?.[attr]} inputStyle={{ width: '110px' }}/>
            </div>
        </div>
    )
}

export default Erlang;